import React from 'react';
import {
  UpdatedDialogContainer,
  UpdatedDialogView,
} from './UpdatedDialog.styled';

import CloseIcon from '../../assets/icons/close.svg';

const UpdatedDialog = ({
  dialogBody,
  minWidth,
  handleClose,
  padding,
  fullWidth,
  showClose = true,
  noHeaderSpacing = false,
  children,
}) => {
  return (
    <UpdatedDialogContainer>
      <UpdatedDialogView
        open
        minWidth={minWidth}
        padding={padding}
        fullWidth={fullWidth}
      >
        {showClose ? (
          <img
            className="close__icon"
            src={CloseIcon}
            alt="close"
            onClick={handleClose}
          />
        ) : (
          <>{noHeaderSpacing ? null : <div className="header-spacing" />}</>
        )}
        <div className="content__container">{children || dialogBody}</div>
      </UpdatedDialogView>
    </UpdatedDialogContainer>
  );
};

export default UpdatedDialog;
